module.exports = __webpack_public_path__ + "img/18_53.6dbc59b2.png";